module.exports = __webpack_public_path__ + "static/media/size-24.faa8ae93.jpg";